module.exports = __webpack_public_path__ + "img/Flag_of_Pakistan.a42fe9db.svg";